var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoVerify = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28298",
    "data-name": "Group 28298",
    transform: "translate(-847 -345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41357",
    "data-name": "Path 41357",
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z",
    transform: "translate(847 345)",
    fill: "#00a1af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20948",
    "data-name": "Group 20948",
    transform: "translate(851.191 350.602)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41185",
    "data-name": "Path 41185",
    d: "M19.546,30.84,15.86,27.155,16.9,26.115l2.646,2.639,5.595-5.595,1.039,1.047Z",
    transform: "translate(-15.86 -23.159)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoVerify);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_verify.150cad70df156f64323e0638f30b7749.svg";